'use strict';

const accountStates = ({ elm }) => {
	return [
		elm({
			name: 'SwitchAccounts',
			moduleName: 'SwitchAccounts.Main',
			url: '/switch-accounts',
			pageTitle: 'listings.navigation.switch_accounts'
		}),
		elm({
			name: 'site.NoPermissions',
			moduleName: 'Common.NoPermissionLightbox',
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				'auth',
				(pmtEnvService, $stateParams, auth) => {
					return auth.getUser($stateParams.site).then(user => {
						const site = $stateParams.site;
						const access = user.accountAccess[site] || {};
						return {
							sitesCount: user.sites ? user.sites.length : 0,
							accountAccess: {
								hasListenRespond: access.hasListenRespond || false,
								hasPlaces: access.hasPlaces || false,
								hasSocialMedia: access.hasSocialMedia || false,
								hasAccountAccess: user.localAccess.roles.has('owner'),
								hasLocator: access.hasLocator || false,
								hasLocalCampaigns: access.hasLocalCampaigns || false,
								hasAiVisibility: access.hasAiVisibility || false
							},
							accountSettings: pmtEnvService.accountSettingsUrl + site,
							listen: pmtEnvService.listenRespondUrl + site,
							social: pmtEnvService.locationPostsUrl + site,
							switchAccounts: pmtEnvService.listingsManagerUrl + 'switch-accounts',
							logout: pmtEnvService.loginUrl + 'logout'
						};
					});
				}
			]
		})
	];
};

module.exports = {
	accountStates
};
